
import breakpointMixin from '~/mixins/breakpoints'

export default {
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.background = this.blok?.colorOverride
      styles.height = this.blok?.height
      styles.margin = this.getBreakpointValue(this.blok?.margin)

      return styles
    },
  },
}
